<template>
  <div :class="questions.category + ' fade-in'" ref="quizview" id="quiz-view">
    <!-- Display Quiz Image -->
    <img :src="QImagePath(questions.category)" />

    <!-- Display Quiz Question -->
    <h1 v-if="settings.lang == 'th'">{{ questions.question_th}}</h1>
    <h1 v-else>{{ questions.question}}</h1>

    <!-- Scale Type Question -->
    <div v-if="questions.type == 'scale'">
      <div id="slider-container">
        <vue-slider v-model="value" :tooltip="'always'" :min="0" :max="10"></vue-slider>
        <p>not likely</p>
        <p>very likely</p>
      </div>

      <!-- Options -->
      <div class="option" @click.prevent="handleSubmit(value, questions.coins, questions.type)">
        SUBMIT
        <div class="coin" :id="coinPath(questions.coins)"></div>
      </div>
    </div>

    <!-- Text Area Type Qustion -->
    <div v-if="questions.type == 'open'">
      <div id="textarea-container">
        <div id="textarea-format">
          <textarea
            v-model="message"
            @click.prevent="scrollToBottom()"
            :placeholder="[questions.placeholder_text ? questions.placeholder_text : 'Enter your feedback here' ]"
          ></textarea>
          <p v-if="error">Please input feedback to submit</p>
        </div>
      </div>

      <!-- Options for Text Area -->
      <div
        class="option skip"
        @click.prevent="handleSubmit('Skipped: ' + message, 0, questions.type)"
      >SKIP</div>
      <div
        class="option textarea"
        @click.prevent="handleSubmit(message, questions.coins, questions.type)"
      >
        SUBMIT
        <div class="coin" :id="coinPath(questions.coins)"></div>
      </div>
    </div>

    <!-- Multiple Type Qustion -->
    <div v-if="questions.type == 'multiple' && settings.lang == 'th'">
      <!-- Options -->
      <div
        v-for="option in questions.options_th"
        :key="option"
        class="option"
        @click.prevent="handleSubmit(option, questions.coins, questions.type)"
      >
        {{ option }}
        <div class="coin" :id="coinPath(questions.coins)"></div>
      </div>
    </div>

    <div v-if="questions.type == 'multiple' && settings.lang == 'en'">
      <!-- Options -->
      <div
        v-for="option in questions.options"
        :key="option"
        class="option"
        @click.prevent="handleSubmit(option, questions.coins, questions.type)"
      >
        {{ option }}
        <div class="coin" :id="coinPath(questions.coins)"></div>
      </div>
    </div>
    <div>
      <audio id="myAudio">
        <source src="@/assets/congratulation.mp3" type="audio/mpeg" />
      </audio>
    </div>
    <div class="anim">
      <lottie
        :options="defaultOptions"
        :height="163"
        :width="320"
        v-on:animCreated="handleAnimation"
      />
    </div>
    <!-- <audio ref="audioElm" src="../assets/sfx-1.mp3" muted="muted"></audio> -->
  </div>
</template>

<script>
import VueSlider from "vue-slider-component";
import "../assets/css/happily.css";
import Lottie from "./lottie.vue";
import * as animationData from "@/assets/coins_attack.json";

export default {
  name: "quiz-view",
  components: {
    VueSlider,
    lottie: Lottie
  },
  props: {
    questions: Object,
    settings: Object
  },
  data() {
    return {
      value: 7,
      message: "",
      error: false,
      defaultOptions: { animationData: animationData.default },
      animationSpeed: 1,
    };
  },
  methods: {
    handleSubmit(responseValue, coinValue, questionType) {
      console.log("Response Value: " + responseValue);
      console.log("Coin Value: " + coinValue);
      console.log("Question Type: " + questionType);

      this.error = false;

      //Check if Text Area field is Empty on Submit
      if (this.invalidTextInput && coinValue != 0 && questionType == "open") {
        this.error = true;
        console.log("Error in Text Input");
        return;
      }

      if (coinValue != 0) {
        const audio = document.getElementById("myAudio");
        audio.currentTime = 0;
        audio.play();

        this.anim.play();
        setTimeout(() => {
          this.anim.stop();
        }, 1000);
      }

      //If Text Area is Skipped
      if (questionType == "open" && coinValue == 0) {
        this.message = "Skipped";
        this.$emit("submit:response", responseValue, coinValue, questionType);
        this.message = '';
      }else{
        setTimeout(() => {
          this.$emit("submit:response", responseValue, coinValue, questionType);
          this.message = '';
        }, 1000);
      }
      
    },
    QImagePath(category) {
      var images = require.context("../assets/", false, /\.png$/);
      return images("./" + category + ".png");
    },
    coinPath(coins) {
      return coins == "1"
        ? "one"
        : coins == "3"
        ? "three"
        : coins == "5"
        ? "five"
        : "";
    },
    scrollToBottom() {
      var container = this.$refs.quizview;
      container.scrollTop = container.scrollHeight;
      console.log("Scroll to Bottom: " + container.scrollHeight);
    },
    handleAnimation: function(anim) {
      this.anim = anim;
      this.anim.stop();
    }
  },
  computed: {
    invalidTextInput() {
      return this.message === "";
    }
  }
};
</script>

<style scoped>
#quiz-view {
  background: rgb(77, 45, 61);
  background: linear-gradient(
    36deg,
    rgba(77, 45, 61, 1) 10%,
    rgba(223, 51, 101, 1) 100%
  );
  bottom: 0;
  color: white;
  display: block;
  font-size: 32px;
  left: 0;
  overflow: scroll;
  position: fixed;
  right: 0;
  top: 0;
  z-index: 90;
}
#quiz-view.feedback {
  background: #254325;
  background: linear-gradient(36deg, #254325 10%, #0ba54c 100%);
}
#quiz-view.happiness {
  background: #8d0057;
  background: linear-gradient(36deg, #8d0057 10%, #ffd612 100%);
}
#quiz-view.relmanager {
  background: #002d4e;
  background: linear-gradient(36deg, #002d4e 10%, #6399ff 100%);
}
img {
  margin: 90px auto 0 auto;
  height: 150px;
}
h1 {
  color: #fff;
  padding: 0 40px;
  font-size: 24px;
  font-weight: 400;
  margin: 12px 0 30px 0;
}
.th-lang h1 {
  font-family: "Kanit";
}
.option {
  font-family: "Lato";
  background: #fff;
  color: #4a4a4a;
  font-size: 16px;
  font-weight: 900;
  width: 80%;
  height: 50px;
  line-height: 50px;
  margin: 0 auto 10px auto;
  border-radius: 6px;
  box-shadow: 0 3px 0 rgb(136, 136, 136);
  position: relative;
  z-index: 999;
}
.th-lang .option {
  font-family: "Kanit";
}
.option:active {
  background: #ccc;
}
.option .coin {
  width: 30px;
  height: 30px;
  display: inline-block;
  position: absolute;
  right: 24px;
  top: 10px;
  background-size: contain !important;
}
.option.textarea {
  width: 48%;
  display: inline-block;
  margin-left: 4%;
}
.option.skip {
  width: 28%;
  display: inline-block;
  background: #9b9b9b;
  color: #fff;
  box-shadow: 0 4px 0 rgb(80, 80, 80);
  margin-bottom: 30px;
}
.option.skip:active {
  background: #666666;
}
.option:last-child {
  margin-bottom: 120px;
}
.coin#one {
  background: url("../assets/coin-1@2x.png");
}
.coin#three {
  background: url("../assets/coin-3@2x.png");
}
.coin#five {
  background: url("../assets/coin-5@2x.png");
}
#slider-container {
  width: 80%;
  margin: 60px auto 80px auto;
  position: relative;
}
#slider-container p {
  font-size: 14px;
  position: absolute;
  top: 30px;
}
#slider-container p:last-child {
  right: 0;
}
#textarea-container {
  width: 80%;
  height: 160px;
  position: relative;
  margin: 0 auto 24px auto;
  background: #fff;
  border-radius: 8px;
}
#textarea-container #textarea-format {
  position: absolute;
  padding: 0;
  top: 20px;
  left: 20px;
  right: 20px;
  bottom: 20px;
  border-radius: 8px;
}
#textarea-format p {
  color: red;
  font-size: 13px;
  position: relative;
  bottom: 32px;
}
#textarea-container textarea {
  width: 100%;
  height: 100%;
  border: 0;
  font-family: "Lato";
  font-size: 16px;
  outline: 0px;
  resize: none;
}
.anim {
  position: absolute;
  bottom: 0;
  margin-left: -160px;
  left: 50%;
  z-index: 1000;
  pointer-events: none;
}
.fade-in {
  -webkit-animation: fade-in 1.2s cubic-bezier(0.39, 0.575, 0.565, 1) both;
  animation: fade-in 1.2s cubic-bezier(0.39, 0.575, 0.565, 1) both;
}
/* ----------------------------------------------
 * Generated by Animista on 2019-8-3 14:50:26
 * w: http://animista.net, t: @cssanimista
 * ---------------------------------------------- */

@-webkit-keyframes fade-in {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@keyframes fade-in {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
</style>